import React from 'react';

import ReplyCard from './ReplyCard';

const ReplySection = ({ replies, loading, ...props }) => {
  //   if (loading) {
  //     return <Loading />;
  //   }

  return (
    <div>
      {replies &&
        replies.map((reply, key) => (
          <p>{<ReplyCard reply={reply} index={key} {...props} />}</p>
        ))}
    </div>
  );
};

export default ReplySection;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/Comments/Replies/ReplySection.js